<div class="firmas-container">
  <!-- Token inválido / enlace expirado por backend -->
  <div class="modal-overlay" *ngIf="tokenInvalido">
    <div class="modal-content">
      <div class="modal-header-error">
        <span class="icono-error">⚠</span>
      </div>
      <div class="modal-body-center">
        <h2>Enlace inválido</h2>
        <p class="mensaje-enlace-usado">
          El enlace de firma no es válido o ha expirado. Por favor solicite uno
          nuevo o comuníquese con su ejecutivo.
        </p>
      </div>
    </div>
  </div>

  <!-- Cargando sesión / datos -->
  <div class="modal-overlay" *ngIf="cargandoSesion || cargandoDatos">
    <div class="modal-content" style="text-align: center; padding: 40px">
      <p style="font-size: 16px; color: #0066cc">
        Cargando información de la solicitud...
      </p>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="enlaceYaUtilizado && !mostrarModalExito">
    <div class="modal-content modal-enlace-usado">
      <div class="modal-header-error">
        <span class="icono-error">⚠</span>
      </div>
      <div class="modal-body-center">
        <h2>Enlace no disponible</h2>
        <p class="mensaje-enlace-usado">
          Su solicitud ya ha sido confirmada mediante firma electrónica. Este
          enlace ha perdido vigencia.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn-aceptar" (click)="cerrarModalEnlaceUsado()">
          Cerrar
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="mostrarModalExito">
    <div class="modal-content modal-exito">
      <div class="modal-header-success">
        <div class="icono-check-grande">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="36" fill="#1E88E5" />
            <path
              d="M25 40 L35 50 L55 30"
              stroke="white"
              stroke-width="4"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div class="modal-body-center">
        <h2 class="titulo-exito">¡Firma Exitosa!</h2>
        <p class="fecha-firma-exito">
          Fecha de firma exitosa:
          <strong>{{ obtenerFechaFirmaFormateada() }}</strong>
        </p>
        <p class="mensaje-exito">
          Gracias por completar el proceso de firma electrónica. Tu solicitud
          será evaluada. El resultado será notificado a tu correo electrónico
          registrado.
        </p>

        <div
          class="info-firma-digital"
          *ngIf="documentos.length > 0 && documentos[0].firmado"
        >
          <p class="texto-firmado">
            Firmado digitalmente por<br />
            <strong>{{ documentos[0].firmante }}</strong
            ><br />
            Fecha: {{ documentos[0].fechaFirma | date: "dd/MM/yyyy HH:mm:ss"
            }}<br />
            <span class="id-transaccion"
              >ID: {{ documentos[0].idTransaccion }}</span
            >
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-aceptar" (click)="cerrarModalExito()">
          Aceptar
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="mostrarModalAlerta">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ tituloAlerta }}</h2>
      </div>
      <div class="modal-body">
        <p style="white-space: pre-line">{{ mensajeAlerta }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn-aceptar" (click)="cerrarModalAlerta()">
          Aceptar
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="mostrarModalCaptcha">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Verificación de seguridad</h2>
      </div>
      <div
        class="modal-body"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
        "
      >
        <p style="margin: 0; text-align: center">
          Por favor confirme que no es un robot para continuar.
        </p>
        <re-captcha
          (resolved)="onCaptchaResuelto($event)"
          (errored)="onCaptchaExpirado()"
        >
        </re-captcha>
      </div>
      <div class="modal-footer">
        <button
          class="btn-aceptar"
          style="background-color: #6c757d"
          (click)="cancelarCaptcha()"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="mostrarModalDocumento">
    <div class="modal-documento">
      <div class="modal-documento-header-white">
        <h2 class="titulo-documento-principal">
          {{ documentoSeleccionado?.nombre }}
        </h2>
        <div class="botones-superiores">
          <button
            class="btn-descargar-doc"
            (click)="descargarDocumento()"
            title="Descargar documento"
          >
            <img
              src="assets/imagenes/svg/download.svg"
              alt="Descargar"
              class="icono-descarga"
            />
          </button>
          <button
            class="btn-cerrar-x"
            (click)="cerrarModalDocumento()"
            title="Cerrar"
          >
            ✕
          </button>
        </div>
      </div>

      <div class="modal-documento-body">
        <iframe
          *ngIf="urlDocumentoPreview"
          [src]="urlDocumentoPreview"
          width="100%"
          height="600px"
          style="border: none"
        ></iframe>
      </div>

      <div class="modal-documento-footer">
        <button class="btn-cerrar-secundario" (click)="cerrarModalDocumento()">
          Cerrar
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="mostrarModal">
    <div class="modal-content">
      <div class="modal-header">
        <h2>FIRMA ELECTRÓNICA</h2>
      </div>

      <div class="modal-body">
        <p [innerHTML]="mensajeFirma"></p>
      </div>

      <div class="modal-footer">
        <button class="btn-aceptar" (click)="aceptarFirmaInicial()">
          He leído y aceptado
        </button>
      </div>
    </div>
  </div>

  <div class="contenido-principal" *ngIf="!mostrarModal">
    <div class="header-portal">
      <img
        src="assets/imagenes/header.webp"
        alt="Header Coomeva"
        class="header-imagen"
      />
      <img
        src="assets/ico_cotizador/ico_logo.png"
        alt="Logo Coomeva"
        class="logo-cliente"
      />
    </div>

    <div class="barra-titulo">
      <h3>PORTAL DE FIRMAS</h3>
    </div>

    <div class="contenido-columnas">
      <div class="columna-izquierda">
        <div class="seccion-card">
          <h3 class="titulo-seccion">Datos de la solicitud</h3>

          <div class="campo">
            <label>Nro. Solicitud</label>
            <span>{{ datosSolicitud.numeroSolicitud }}</span>
          </div>

          <div class="campo">
            <label>Tipo de solicitud</label>
            <span>{{ datosSolicitud.tipoSolicitud }}</span>
          </div>

          <div class="campo">
            <label>Detalle de solicitud</label>
            <a href="#" class="link-detalle">{{
              datosSolicitud.detalleSolicitud
            }}</a>
          </div>

          <div class="campo">
            <label>Identificación Contratante</label>
            <span>{{ datosSolicitud.identificacionContratante }}</span>
          </div>

          <div class="campo">
            <label>Nombre contratante</label>
            <span>{{ datosSolicitud.nombreContratante }}</span>
          </div>

          <div class="campo-tabla">
            <label>Usuarios a trasladar</label>
            <table class="tabla-usuarios">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Identificación</th>
                  <th>Nombre usuario</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let usuario of usuariosATrasladar">
                  <td>{{ usuario.no }}</td>
                  <td>{{ usuario.identificacion }}</td>
                  <td>{{ usuario.nombreUsuario }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="columna-derecha">
        <div class="seccion-card aviso-card">
          <div class="aviso-header">
            <span class="icono-aviso">⚠</span>
            <h3>Aviso</h3>
          </div>
          <p class="texto-aviso">{{ mensajeAviso }}</p>
        </div>

        <div class="seccion-card documentos-card">
          <h3 class="titulo-seccion">Documentos</h3>

          <div class="info-documentos">
            <img
              src="assets/imagenes/svg/document.svg"
              alt="Documentos"
              class="icono-documento-img"
            />
            <p>
              Su firma electrónica se aplicará a los documentos listados a
              continuación.<br />
              Para revisar su contenido, haga clic en cada enlace:
            </p>
          </div>

          <div class="lista-documentos">
            <div
              class="documento-item"
              *ngFor="let doc of documentos; let i = index"
            >
              <img
                src="assets/imagenes/svg/eye.svg"
                alt="Ver"
                class="icono-ojo"
                (click)="verDocumento(i)"
              />
              <a
                href="javascript:void(0)"
                (click)="verDocumento(i)"
                class="nombre-documento"
              >
                {{ doc.nombre }}
              </a>
            </div>
          </div>

          <div class="checkbox-aceptacion">
            <input
              type="checkbox"
              id="aceptoTerminos"
              [(ngModel)]="aceptoTerminos"
              (change)="onCheckboxChange()"
            />
            <label for="aceptoTerminos">
              He leído y acepto los términos de los documentos que serán
              firmados electrónicamente.
            </label>
          </div>

          <div class="seccion-otp" *ngIf="mostrarSeccionOTP">
            <h3 class="titulo-otp">Verificación por OTP</h3>

            <div class="mensaje-info-otp">
              <img
                src="assets/imagenes/svg/info-icon.svg"
                alt="Info"
                class="icono-info-otp"
                onerror="this.style.display = 'none'"
              />
              <p>
                Para firmar los documentos, ingrese el código de verificación de
                un solo uso (OTP) que se le ha enviado al
                <strong>{{ canalesEnvioMascarado }}</strong
                >.
              </p>
            </div>

            <div class="contenedor-otp-horizontal">
              <div class="campo-otp-izquierda">
                <input
                  type="text"
                  [(ngModel)]="codigoOTP"
                  (keydown)="validarTeclaOTP($event)"
                  (input)="validarCaracteres($event); onCodigoOTPChange()"
                  maxlength="6"
                  class="input-otp"
                  autocomplete="one-time-code"
                  [disabled]="!puedeIngresarCodigo()"
                />
                <div
                  class="temporizador-otp"
                  *ngIf="tiempoRestanteOTP > 0 && !otpState.otpExpirado"
                >
                  <span class="icono-reloj">⏱</span>
                  <span class="tiempo-restante"
                    >El código vence en: {{ formatearTiempo() }} minutos</span
                  >
                </div>

                <div
                  class="mensaje-expirado"
                  *ngIf="
                    otpState.otpSolicitado &&
                    (otpState.otpExpirado || tiempoRestanteOTP <= 0)
                  "
                >
                  <span class="icono-alerta">⚠</span>
                  <span class="texto-expirado">El código enviado venció</span>
                </div>

                <div class="mensaje-bloqueado" *ngIf="otpState.otpBloqueado">
                  <span class="icono-bloqueado">🔒</span>
                  <span class="texto-bloqueado">
                    Código bloqueado por superar el número máximo de intentos
                    fallidos. Contacte a soporte.
                  </span>
                </div>
              </div>

              <div class="botones-otp-derecha">
                <button
                  class="btn-firmar"
                  [disabled]="procesandoFirma"
                  (click)="firmarDocumentos()"
                  title="Haz clic para firmar electrónicamente los documentos asociados a esta solicitud."
                >
                  <span *ngIf="!procesandoFirma">Firmar</span>
                  <span *ngIf="procesandoFirma">Procesando...</span>
                </button>

                <button
                  class="btn-solicitar-nuevo-otp"
                  [disabled]="!puedeHabilitarBotonReenvio()"
                  (click)="solicitarNuevoOTP()"
                  [title]="
                    puedeHabilitarBotonReenvio()
                      ? '¿No recibiste el código o ya venció? Haz clic en Reenviar OTP para obtener uno nuevo'
                      : 'Espere a que el código actual expire'
                  "
                >
                  Solicitar nuevo código OTP
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
